/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Parameter } from '../app/services/workflow.service';
import { SettingType } from './enums';

export class Settings {
  public static plex: Parameter = {
    name: 'plex',
    label: 'SDE_2SIDED_SCANNING',
    icon: 'duplex-sided',
    selectedValue: {
      key: 'SDE_2SIDED',
      value: 'TWO_SIDED',
      icon: 'duplex-sided',
      title: '',
      options: null,
    },
    type: SettingType.Select,
    options: [
      {
        key: 'SDE_1SIDED',
        value: 'ONE_SIDED',
        icon: 'duplex-sided-one',
        title: '',
        options: null,
      },
      {
        key: 'SDE_2SIDED',
        value: 'TWO_SIDED',
        icon: 'duplex-sided',
        title: '',
        options: null,
        isDefault: true,
      },
      {
        key: 'SDE_2SIDED_ROTATE_SIDE',
        value: 'SECOND_SIDE_ROTATION',
        icon: 'duplex-sided-rotate',
        title: '',
        options: null,
      },
    ],
    selectedValue2: {
      key: '',
      value: '',
      title: '',
      options: null,
    },
    options2: [],
    placeholder: '',
    required: false,
    setDocumentLanguage: '',
    toLanguage: '',
    optionListName: '',
    optionListName2: '',
  };

  public static mediaSize: Parameter = {
    name: 'mediaSize',
    label: 'SDE_ORIGINAL_SIZE',
    icon: 'original-size',
    selectedValue: {
      key: 'SDE_AUTO_DETECT',
      value: 'AUTO',
      icon: 'original-size',
      glyph: '',
      title: '',
      options: null,
    },
    type: SettingType.Select,
    options: [
      {
        key: 'SDE_AUTO_DETECT',
        value: 'AUTO',
        icon: 'original-size',
        glyph: '',
        isDefault: true,
        title: '',
        options: null,
      },
      {
        key: 'SDE_55_X_72',
        value: 'NA_5.5x7SEF',
        icon: '',
        glyph: 'xgl-landscape',
        title: '',
        options: null,
      },
      {
        key: 'SDE_55_X_72',
        value: 'NA_5.5x7LEF',
        icon: '',
        glyph: 'xgl-portrait',
        title: '',
        options: null,
      },
      {
        key: 'SDE_55_X_854',
        value: 'NA_5.5x8.5SEF',
        icon: '',
        glyph: 'xgl-landscape',
        title: '',
        options: null,
      },
      {
        key: 'SDE_55_X_854',
        value: 'NA_5.5x8.5LEF',
        icon: '',
        glyph: 'xgl-portrait',
        title: '',
        options: null,
      },
      {
        key: 'SDE_85_X_114',
        value: 'NA_8.5x11SEF',
        icon: '',
        glyph: 'xgl-landscape',
        title: '',
        options: null,
      },
      {
        key: 'SDE_85_X_114',
        value: 'NA_8.5x11LEF',
        icon: '',
        glyph: 'xgl-portrait',
        title: '',
        options: null,
      },
      {
        key: 'SDE_85_X_134',
        value: 'NA_8.5x13SEF',
        icon: '',
        glyph: 'xgl-landscape',
        title: '',
        options: null,
      },
      {
        key: 'SDE_85_X_143',
        value: 'NA_8.5x14SEF',
        icon: '',
        glyph: 'xgl-landscape',
        title: '',
        options: null,
      },
      {
        key: 'SDE_11_X_173',
        value: 'NA_11x17SEF',
        icon: '',
        glyph: 'xgl-landscape',
        title: '',
        options: null,
      },
      {
        key: 'SDE_A51',
        value: 'ISO_A5SEF',
        icon: '',
        glyph: 'xgl-landscape',
        title: '',
        options: null,
      },
      {
        key: 'SDE_A51',
        value: 'ISO_A5LEF',
        icon: '',
        glyph: 'xgl-portrait',
        title: '',
        options: null,
      },
      {
        key: 'SDE_A41',
        value: 'ISO_A4SEF',
        icon: '',
        glyph: 'xgl-landscape',
        title: '',
        options: null,
      },
      {
        key: 'SDE_A41',
        value: 'ISO_A4LEF',
        icon: '',
        glyph: 'xgl-portrait',
        title: '',
        options: null,
      },
      {
        key: 'SDE_A31',
        value: 'ISO_A3SEF',
        icon: '',
        glyph: 'xgl-landscape',
        title: '',
        options: null,
      },
      {
        key: 'SDE_B5',
        value: 'JIS_B5SEF',
        icon: '',
        glyph: 'xgl-landscape',
        title: '',
        options: null,
      },
      {
        key: 'SDE_B5',
        value: 'JIS_B5LEF',
        icon: '',
        glyph: 'xgl-portrait',
        title: '',
        options: null,
      },
      {
        key: 'SDE_B4',
        value: 'JIS_B4SEF',
        icon: '',
        glyph: 'xgl-landscape',
        title: '',
        options: null,
      },
    ],
    selectedValue2: {
      key: '',
      value: '',
      title: '',
      options: null,
    },
    options2: [],
    placeholder: '',
    required: false,
    setDocumentLanguage: '',
    toLanguage: '',
    optionListName: '',
    optionListName2: '',
  };

  public static printPlex: Parameter = {
    name: 'plex',
    label: 'SDE_2SIDED_PRINTING2',
    icon: 'duplex-sided',
    selectedValue: {
      key: 'SDE_1SIDED',
      value: 'OneSided',
      icon: 'duplex-sided-one',
      title: '',
      options: null,
    },
    type: SettingType.Select,
    options: [
      {
        key: 'SDE_1SIDED',
        value: 'OneSided',
        icon: 'duplex-sided-one',
        title: '',
        options: null,
      },
      {
        key: 'SDE_2SIDED',
        value: 'TwoSided',
        icon: 'duplex-sided-two',
        isDefault: true,
        title: '',
        options: null,
      },
    ],
    selectedValue2: {
      key: '',
      value: '',
      title: '',
      options: null,
    },
    options2: [],
    placeholder: '',
    required: false,
    setDocumentLanguage: '',
    toLanguage: '',
    optionListName: '',
    optionListName2: '',
  };

  public static quantity: Parameter = {
    name: 'quantity',
    label: 'SDE_QUANTITY',
    icon: 'page-quantity',
    maxlength: 3,
    pattern: '^([1-9][0-9]|[1-9])$',
    selectedValue: { value: '1', key: '', title: '', options: null },
    type: SettingType.NumberCount,
    options: [
      { value: '1', isDefault: true, key: '', title: '', options: null },
    ],
    selectedValue2: {
      key: '',
      value: '',
      title: '',
      options: null,
    },
    options2: [],
    placeholder: '',
    required: false,
    setDocumentLanguage: '',
    toLanguage: '',
    optionListName: '',
    optionListName2: '',
  };

  public static printColorMode: Parameter = {
    name: 'colorMode',
    label: 'SDE_OUTPUT_COLOR2',
    icon: 'output-color-full ',
    selectedValue: {
      key: 'SDE_AUTO_DETECT',
      value: 'Auto',
      icon: 'output-color-auto',
      title: '',
      options: null,
    },
    type: SettingType.Select,
    options: [
      {
        key: 'SDE_AUTO_DETECT',
        value: 'Auto',
        icon: 'output-color-auto',
        isDefault: true,
        title: '',
        options: null,
      },
      {
        key: 'SDE_COLOR',
        value: 'Color',
        icon: 'output-color-full',
        title: '',
        options: null,
      },
      {
        key: 'SDE_BLACK_WHITE',
        value: 'MonochromeGrayscale',
        icon: 'output-color-b-w',
        title: '',
        options: null,
      },
      {
        key: 'SDE_GRAYSCALE',
        value: 'MonochromeGrayscale',
        icon: 'output-color-gray',
        title: '',
        options: null,
      },
    ],
    selectedValue2: {
      key: '',
      value: '',
      title: '',
      options: null,
    },
    options2: [],
    placeholder: '',
    required: false,
    setDocumentLanguage: '',
    toLanguage: '',
    optionListName: '',
    optionListName2: '',
  };

  public static stapling: Parameter = {
    name: 'stapling',
    label: 'SDE_STAPLING',
    icon: 'stapling-1',
    selectedValue: {
      key: 'SDE_OFF',
      value: 'false',
      icon: 'stapling-none',
      title: '',
      options: null,
    },
    type: SettingType.Select,
    options: [
      {
        key: 'SDE_ON',
        value: 'true',
        icon: 'stapling-1',
        title: '',
        options: null,
      },
      {
        key: 'SDE_OFF',
        value: 'false',
        icon: 'stapling-none',
        isDefault: true,
        title: '',
        options: null,
      },
    ],
    selectedValue2: {
      key: '',
      value: '',
      title: '',
      options: null,
    },
    options2: [],
    placeholder: '',
    required: false,
    setDocumentLanguage: '',
    toLanguage: '',
    optionListName: '',
    optionListName2: '',
  };

  public static Scan = [Settings.plex, Settings.mediaSize];
  public static Print = [
    Settings.quantity,
    Settings.printPlex,
    Settings.printColorMode,
    Settings.stapling,
  ];

  // return nothing...this is a MFD only feature and will be
  public static getScanValues(scanSettings: Parameter[]) {
    console.log(scanSettings);
    return;
  }
}
